import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import {
  CLIENT_ACCESS_TOKEN_KEY,
  fnGetKeyByValue,
  MemberRole,
} from '@malirang/common';
import { LocalStorageService, ToastService } from '@malirang/front-share';
import { injectNavigationEnd } from 'ngxtension/navigation-end';
import { CenterStore } from '../stores/center/center.store';
import { CenterRoleStore } from '../stores/center/role.store';
import { CenterUserStore } from '../stores/center/user.store';
import { UserStore } from '../stores/user.store';
import { AuthGuardComponent } from './auth-guard/auth-guard.component';
import { CenterGuardComponent } from './center-guard/center-guard.component';
import { GuardStore } from './guard.store';

@Component({
  selector: 'app-guard',
  templateUrl: './guard.component.html',
  imports: [
    CommonModule,
    RouterOutlet,
    CenterGuardComponent,
    AuthGuardComponent,
  ],
  providers: [GuardStore],
})
export class GuardComponent implements OnInit {
  readonly centerStore = inject(CenterStore);
  readonly centerRoleStore = inject(CenterRoleStore);
  readonly centerUserStore = inject(CenterUserStore);
  readonly userStore = inject(UserStore);
  readonly guardStore = inject(GuardStore);

  readonly route = inject(ActivatedRoute);
  readonly router = inject(Router);
  readonly localStorageService = inject(LocalStorageService);
  readonly toastService = inject(ToastService);
  readonly navigationEnd$ = injectNavigationEnd();

  render = signal(false);

  ngOnInit() {
    // 인증 처리
    this.handleAuthenticating();

    // path 설정
    this.guardStore.setPath(this.router.url);
    this.navigationEnd$.subscribe({
      next: (event) => {
        this.guardStore.setPath(event.url);
      },
    });

    // 센터 정보가 변경될 때마다 현재 페이지의 권한을 체크합니다.
    this.centerStore.currentCenter$.subscribe({
      next: () => {
        this.route.children.map((child) => {
          this.handleRequiredRoles(child);
        });
      },
    });
  }

  /**
   * 인증 처리
   */
  async handleAuthenticating() {
    const accessToken = this.localStorageService.get(CLIENT_ACCESS_TOKEN_KEY);

    if (accessToken) {
      try {
        const user = await this.userStore.fetchUser();

        if (user) {
          // if (
          //   !user.roles.includes(
          //     fnGetKeyByValue(MemberRole, MemberRole.TEACHER),
          //   )
          // ) {
          //   this.userStore.clearUser();
          //   this.toastService.error('선생님만 이용할 수 있습니다.');
          //   this.localStorageService.clear();
          //   window.location.href = '/login';
          // }

          this.userStore.setUser(user);

          // 센터 정보가 있는 경우 센터 정보를 가져옴
          if (user.centerCount) {
            await this.centerStore.fetchCenters();
            await this.centerStore.fetchCount();
            await this.centerUserStore.fetchCenterUser();
          } else {
            // 로그인 후 첫 진입 시 가이드 모달 오픈
            const accessed = this.localStorageService.get('firstAccess');
            if (!accessed) {
              this.guardStore.openGuideModal();
              this.localStorageService.set('firstAccess', true);
            }
          }
        }
      } catch {
        this.userStore.clearUser();
      }
    }

    this.render.set(true);
  }

  /**
   * route에 설정된 requiredRoles를 확인하여 권한이 없는 경우 no-role 페이지로 이동합니다.
   * (children이 존재할 경우 재귀적으로 호출합니다.)
   * @param route
   */
  handleRequiredRoles(route: ActivatedRoute) {
    const roles = route.snapshot.data['requiredRoles'] || [];
    if (roles.length) {
      const myRole = this.centerRoleStore.myRole();
      if (myRole) {
        roles.map((role: string) => {
          if (!myRole.permissions.includes(role)) {
            this.router.navigate(['/no-role']);
          }
        });
      }
    }

    if (route.children.length > 0) {
      route.children.map((child) => {
        this.handleRequiredRoles(child);
      });
    }
  }
}
